var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},_vm._l((_vm.socialMedia),function(social,i){return _c('v-btn',{key:i,attrs:{"href":social.link,"target":"_blank","icon":"","dark":_vm.dark,"small":!_vm.large}},[_c('Icon',{attrs:{"icon":social.icon,"width":"15"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }